const clientToken = import.meta.env.VITE_PAYMENTS_CLIENT_TOKEN as string | undefined;

export function PaymentTestModeBanner() {
  if (!clientToken?.startsWith("pk_test_")) return null;
  return (
    <div className="w-full rounded-2xl bg-warm/30 border border-warm/50 px-4 py-2 text-center text-sm text-warm-foreground">
      Test mode — payments in preview don't charge real money.
    </div>
  );
}

export default PaymentTestModeBanner;
